import { ProductContent } from '@common'
import Image from 'next/image'

import BgFlare from '@/assets/images/storefronts/clashofclans/shop_item_bg_flare.png'
import { useProductImage } from '@/features/storefronts/_storeBase/card/utils'
import { ImageWithFallback } from '@/features/storefronts/_storeBase/imageWithFallback/ImageWithFallback'
import { StoreTypography } from '@/features/storefronts/_storeBase/typography/StoreTypography'
import { useTranslatable } from '@/localization/useTranslatable'

import styles from './ClashItem.module.scss'

type Props = {
  content: ProductContent
}

export const ClashItem = ({ content }: Props) => {
  const translatable = useTranslatable()
  const { imageSrc } = useProductImage({ game: 'clashofclans', productId: content.product.id, count: content.amount })

  return (
    <div className={styles.Card}>
      <StoreTypography tag="h5" style="outlined" textSize="sm" className={styles.Heading}>
        {translatable(content.product.title)}
      </StoreTypography>
      <div className={styles.ImageContainer}>
        <div className={styles.FlareContainer}>
          <Image src={BgFlare} unoptimized alt="" className={styles.Flare} />
        </div>
        <div className={styles.ImageWrapper}>
          <ImageWithFallback
            productImage={imageSrc}
            title={translatable(content.product.title)}
            className={styles.Image}
          />
        </div>
      </div>
      <div className={styles.Footer}>
        <StoreTypography tag="p" style="outlined" textSize="body" className={styles.FooterText}>
          {content.amount}
        </StoreTypography>
      </div>
    </div>
  )
}
